import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';

import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ApiBoardComment } from '../../api-client-module';

import { MessageDialogComponent } from '../../common/message-dialog/message-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface boardCommentDialogData {
  boardComment?: ApiBoardComment,
  isBrowse: boolean;
}

@Component({
  selector: 'app-board-comment-dialog',
  templateUrl: './board-comment-dialog.component.html',
  styleUrls: ['./board-comment-dialog.component.css'],
  standalone: false,
})
export class BoardCommentDialogComponent implements OnInit {

  @ViewChild('fileInput1') fileInput1!: ElementRef;
  @ViewChild('fileInput2') fileInput2!: ElementRef;

  boardComment?: any;
  isBrowse: boolean = false;
  isAdded: boolean = false;

  boardCommentFormGroup!: FormGroup;
  commentDescControl!: FormControl;

  //  マウスホバー時の変化
  isHovering: boolean = false;
  //  画像ファイル
  image_file: File = null as any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BoardCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boardCommentDialogData,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.boardComment = this.data.boardComment;
    this.isBrowse = this.data.isBrowse!;
    if (!this.boardComment) {
      this.boardComment = {
        comment_desc: '',
        comment_image: null as any,
        comment_owner: ''
      };
      this.isAdded = true;
    }
    this.createForm();
    this.commentDescControl = this.boardCommentFormGroup.get('commentDesc') as FormControl;
  }

  public getErrorMessageToCommentDesc() {
    return this.commentDescControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  private createForm() {
    this.boardCommentFormGroup = this.formBuilder.group(
      {
        commentDesc: [this.boardComment!.comment_desc, [Validators.required]],
      }
    );
  }

  addComment(): void {
    if (this.boardCommentFormGroup.valid) {
      this.boardComment!.comment_desc = this.commentDescControl.value;
      this.boardComment['file'] = this.image_file;
      this.dialogRef.close(this.boardComment);
    }
  }

  updComment(): void {
    if (this.boardCommentFormGroup.valid) {
      this.boardComment!.comment_desc = this.commentDescControl.value;
      this.boardComment['file'] = this.image_file;
      this.boardComment['isDelete'] = false;
      this.dialogRef.close(this.boardComment);
    }
  }

  delComment(): void {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '420px',
      height: '180px',
      disableClose: true,
      data: { message: this.translate.instant('コメントを削除します。よろしいですか？') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        if (this.boardCommentFormGroup.valid) {
          this.boardComment!.comment_desc = this.commentDescControl.value;
          this.boardComment['file'] = this.image_file;
          this.boardComment['isDelete'] = true;
          this.dialogRef.close(this.boardComment);
        }
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onChangeFile1Input(event: Event) {
    this.image_file = null as any;
    const target = event.target as HTMLInputElement;
    if (target.files!.length > 0) {
      this.image_file = target.files!.item(0)!;
    }
  }

  onChangeFile2Input(event: Event) {
    this.image_file = null as any;
    const target = event.target as HTMLInputElement;
    if (target.files!.length > 0) {
      this.image_file = target.files!.item(0)!;
    }
  }

  onFile1ClearClick() {
    this.image_file = null as any;
    this.fileInput1.nativeElement.value = "";
  }

  onFile2ClearClick() {
    this.image_file = null as any;
    this.fileInput2.nativeElement.value = "";
  }

  onImageClearClick() {
    this.image_file = null as any;
    this.boardComment.comment_image = null;
  }
}
